export default __webpack_public_path__ + "static/media/background-banner.363efb11.jpeg";